import "./CreateStoreModal.css";
import PopUp from "../../components/PopUp";
import { ModifyStoreForm } from "./modifyStoreForm.js";

export default function ModifyStoreModal(props) {
  return (
    <div className="create-store-container">
      <PopUp handleSubmit={props.togglePopUp} title={props.title}>
        <ModifyStoreForm {...props} />
      </PopUp>
    </div>
  );
}
